import React from 'react';
import {useTranslation} from 'react-i18next';
import {Button, Dialog, DialogFooter} from '@taopix/taopix-design-system';
import {useUiState} from '../../Context/UserInterface/UserInterfaceContext';
import {UserInterfaceActions} from '../../Context/UserInterface/UserInterfaceActionTypes';
import {DialogStatus} from '../../../Enums';

type AlternativeProductsUnavailableNotificationProps = {
  open: boolean;
};

const AlternativeProductsUnavailableNotification = ({
  open,
}: AlternativeProductsUnavailableNotificationProps) => {
  const {t} = useTranslation(['*', 'dialogs']);
  const ui = useUiState();

  const closeDialog = () => {
    ui.dispatch(
      UserInterfaceActions.setDialogStatus({alternativeProductsUnavailable: DialogStatus.Closed})
    );
  };

  return (
    <Dialog
      open={open}
      theme={'tpx-theme-dialogs'}
      themeTip="Dialogs"
      title={t('dialogs:str_TitleAlternativeProductsUnavailable', {
        defaultValue: 'Alternative Products Unavailable',
      })}
      showTitle={false}
      aria-live="assertive"
    >
      <div className={'p-md'}>
        <p>{t('*:str_MessageNoAlternativeProductsAvailable')}</p>
      </div>
      <DialogFooter>
        <Button label={t('*:str_ButtonOK')} buttonStyle={'primary'} onClick={closeDialog} />
      </DialogFooter>
    </Dialog>
  );
};

export default AlternativeProductsUnavailableNotification;
